//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';

import { PurchaseOption } from '@apis/campaign-requests/sampling/opportunities/samplingOpportunitiesApiModel';
import { TableRow } from '@components/organisms/table/TableRow';

import { PrepaidPurchaseOptionsTableRowContent } from './PrepaidPurchaseOptionsTableRowContent';

interface PrepaidPurchaseOptionsTableRowReadOnlyProps {
  onRequestCampaign?: (purchaseOption: PurchaseOption) => void;
  purchaseOption: PurchaseOption;
  showRequestCampaignButton?: boolean;
}

export const PrepaidPurchaseOptionsTableRowReadOnly = ({
  onRequestCampaign,
  purchaseOption,
  showRequestCampaignButton,
}: PrepaidPurchaseOptionsTableRowReadOnlyProps) => {
  return (
    <TableRow>
      <PrepaidPurchaseOptionsTableRowContent
        onRequestCampaign={onRequestCampaign}
        purchaseOption={purchaseOption}
        showRequestCampaignButton={showRequestCampaignButton}
      />
    </TableRow>
  );
};
